export default __webpack_public_path__ + "static/about2-f7a409f9299d6298e1d7808bac061f48.webp";